import { supabase } from '@/lib/supabase'
import type { ListSubscriptionsParams, ListSubscriptionsResult } from '../types'

// Consome a Edge Function já agregada/paginada por conta
export async function listSubscriptions({ search = '', status = '', page = 1, pageSize = 25 }: ListSubscriptionsParams): Promise<ListSubscriptionsResult> {
  try {
    const { data, error } = await supabase.functions.invoke('admin-subscription-list', { body: { search, status, page, pageSize } as any })
    if (error) throw error
    const payload = Array.isArray(data) ? (data as any)[0] : (data as any)
    if (payload?.error) throw new Error(payload.error)
    const items = (payload?.items || []) as any[]
    const total = Number(payload?.total || items.length)
    return { items, total }
  } catch (e) {
    console.warn('listSubscriptions (admin) fallback:', e)
    return { items: [], total: 0 }
  }
}
